// extracted by mini-css-extract-plugin
export const contact = "contact-form-section-module--contact--qJx-S";
export const copy = "contact-form-section-module--copy--2z3rK";
export const form = "contact-form-section-module--form--1cRrh";